export default __webpack_public_path__ + "static/media/certificate.e617cd6a.svg";